import React, { useRef, useEffect } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import styles from "../styles/Footer.module.css";
import Image from "next/image"; // ✅ Optimized Image

const Footer = React.memo(function Footer() {
  const { t } = useTranslation("common"); // ✅ Specify the "common" namespace

  const mountedRef = useRef();
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, [mountedRef]); // ✅ Added dependency to fix exhaustive-deps warning

  return (
    <footer className={`${styles.page_footer}`}>
      <div className={`container text-center mb-0`}>
        <div className="row">
          <div className="col-lg-12">
            <Link href="/" scroll={true}>
              <h3
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: 40,
                }}
              >
                <Image
                  src="/logo.webp"
                  alt="ILovePDF Tools Logo"
                  width={160}
                  height={80}
                  style={{ objectFit: "contain" }}
                  priority
                />
              </h3>
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center">
            <ul className={`${styles.footer_menu}`}>
              <li>
                <Link href="/about" prefetch={false}>
                  {t("about")}
                </Link>
              </li>
              <li>
                <Link href="/privacy-policy" prefetch={false}>
                  {t("privacy")}
                </Link>
              </li>
              <li>
                <Link href="/terms-of-use" prefetch={false}>
                  {t("terms")}
                </Link>
              </li>
              <li>
                <Link href="/contacts" prefetch={false}>
                  {t("contact")}
                </Link>
              </li>
              <li>
                <Link href="/blogs" prefetch={false}>
                  {t("blogs")}
                </Link>
              </li>
              <li>
                <Link href="/faq" prefetch={false}>
                  {t("faq")}
                </Link>
              </li> {/* ✅ Newly added FAQ link */}
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 py-3 d-flex justify-content-center">
            <p className={`text-center ${styles.copyright}`}>
              Copyright &copy;{" "}
              <Link href="/" target="_blank">
                I Love PDF Tools 2025
              </Link>
              . {t("all_rights")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
